// frontend/src/components/Provider/ProviderEmptyState.tsx
// UPDATED: Empty state component

import React from 'react';
import { Shield, Plus } from 'lucide-react';

interface ProviderEmptyStateProps {
  onCreateNew: () => void;
}

const ProviderEmptyState: React.FC<ProviderEmptyStateProps> = ({
  onCreateNew
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-8">
      <div className="text-center">
        <Shield className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No providers found</h3>
        <p className="mt-1 text-sm text-gray-500">
          Get started by adding a new provider to the system.
        </p>
        <div className="mt-6">
          <button
            onClick={onCreateNew}
            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <Plus className="h-4 w-4 mr-1" />
            Add Provider
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProviderEmptyState;